var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item \xE2\x86\x92 Link \xE2\x86\x92 SVG",
    clipPath: "url(#clip0_26_4793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Border_Arrow_Right",
    d: "M14.0912 6.66851L7.55716 0.134429C7.46884 0.0461119 7.35297 0.0028254 7.23754 0.00369767C7.23405 0.00369767 7.23144 0.00195312 7.22791 0.00195312H0.669336C0.427971 0.00195312 0.23211 0.197851 0.23211 0.439179C0.23211 0.442669 0.233854 0.445285 0.233854 0.448811C0.233418 0.564241 0.276705 0.680108 0.364586 0.768426L6.59348 6.99732L0.351466 13.2393C0.176139 13.4146 0.176139 13.6988 0.351466 13.8742C0.45552 13.9782 0.596756 14.0128 0.731849 13.9935H7.16405C7.29915 14.0127 7.44038 13.9782 7.54444 13.8742L14.0908 7.32784C14.1817 7.2369 14.2232 7.11707 14.2198 6.99772C14.2233 6.87924 14.1817 6.75944 14.0912 6.66851ZM7.03027 13.1191H1.74143L7.53219 7.32831C7.62312 7.23738 7.66467 7.11755 7.66118 6.99819C7.66467 6.87927 7.62312 6.75944 7.53219 6.66851L1.74056 0.876406H7.03158L13.1525 6.99728L7.03027 13.1191Z",
    fill: "#10417A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_4793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.219971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/BlueArrow.bfe6b45ae2d6cc0d2f173c22a0fec00f.svg";
export { ForwardRef as ReactComponent };